/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .fill {
    fill: ${theme.color.gray};
  }
`

export default function TimeIco() {
  return (
    <Fragment>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10.051" viewBox="0 0 10 10.051" css={Color} className="time-icon">
        <g id="그룹_35021" data-name="그룹 35021" transform="translate(-234 -545)">
          <g id="그룹_34979" data-name="그룹 34979" transform="translate(235.108 545.517)">
            <path id="합치기_794" data-name="합치기 794"
              d="M-7720.107-12531.858a4.38,4.38,0,0,1,3.874-4.348v-.312h-.261a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.526a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.264v.313a4.361,4.361,0,0,1,2.349,1.028l.14-.141a.5.5,0,0,1,.019-.687.5.5,0,0,1,.708,0l.667.667a.5.5,0,0,1,0,.708.5.5,0,0,1-.353.145.5.5,0,0,1-.335-.126l-.167.167a4.352,4.352,0,0,1,.848,2.586,4.379,4.379,0,0,1-4.376,4.374A4.377,4.377,0,0,1-7720.107-12531.858Zm1,0a3.38,3.38,0,0,0,3.376,3.376,3.378,3.378,0,0,0,3.376-3.376,3.379,3.379,0,0,0-3.376-3.376A3.381,3.381,0,0,0-7719.11-12531.858Zm2.876,0v-2.1a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.1a.5.5,0,0,1-.5.5A.5.5,0,0,1-7716.234-12531.858Z"
              transform="translate(7719.608 12537.018)" fill="#acacac" className="fill"/>
          </g>
        </g>
      </svg>
    </Fragment>
  )
}
